import { render, staticRenderFns } from "./AddFundsToReserveView.vue?vue&type=template&id=a78bc47c&"
import script from "./AddFundsToReserveView.vue?vue&type=script&lang=js&"
export * from "./AddFundsToReserveView.vue?vue&type=script&lang=js&"
import style0 from "./AddFundsToReserveView.vue?vue&type=style&index=0&id=a78bc47c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports